import { Routes, Route } from 'react-router-dom';
import Main from '../../../component/Main';
import NewBoardList from './NewBoardList';
import NewBoardDetail from './NewBoardDetail';
import NewBoardWrite from './NewBoardWrite';

function BoardLayout({boardTypeCode}) {
    
    return (
        <Main>
            <Routes>
                <Route path="/" element={<NewBoardList boardTypeCode={boardTypeCode} />} />
                <Route path="/:nttSno" element={<NewBoardDetail boardTypeCode={boardTypeCode} />} />
                <Route path="/write" element={<NewBoardWrite boardTypeCode={boardTypeCode} />} />
                <Route path="/edit/:nttSno" element={<NewBoardWrite boardTypeCode={boardTypeCode} />} />
                <Route path="/reply/:nttSno" element={<NewBoardWrite boardTypeCode={boardTypeCode} />} />
            </Routes>
        </Main>
    );
}

export default BoardLayout;